<template>
  <b-modal id="modal-request" ref="modal" size="xl" title="Request" @show="setData" @hidden="resetModal"
           @ok="handleOk">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend><em class="fa fa-calendar"></em> Work from Home Request</legend>
              <div class="form-row">
                <label class="col-md-3">Employee</label>
                <div class="col-md-6 mb-3">
                      {{emp_name}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Reason</label>
                <div class="col-md-6 mb-3">
                  <b-form-textarea rows="3" v-model="input_data.reason" max-rows="6"></b-form-textarea>
                </div>
              </div>
              <hr>
              <legend><em class="fa fa-book"></em> Work from Home - Duty and Project</legend>
              <div class="form-group">
                <div class="table-responsive">
                  <button type="button" class="btn btn-success btn-sm" @click="addItem" data-title="Add">
                    <em class="fa fa-plus mr-1"></em>Add</button>
                  <table class="table table-hover table-striped" aria-label="Work from Home">
                    <thead>
                    <tr>
                      <th style="width:20px" id="no">No</th>
                      <th style="width:20px" id="action">Action</th>
                      <th style="width:200px" id="project">Project</th>
                      <th style="width:100px" id="date">Date</th>
                      <th style="width:20px" id="hours">Hours</th>
                      <th style="width:100px" id="notes">Notes</th>
                    </tr>
                    </thead>
                    <tbody id="tickets-body">
                    <tr v-for="(item, i) in items">
                      <td>{{i+1}}</td>
                      <td><button type="button" class='btn btn-reset' @click="deleteItem(i)"> <em class='fa fa-trash mr-1'></em></button></td>
                      <td><v-select :options="option_project" v-model="item.project_id" :reduce="val=>val.id" label="name"/></td>
                      <td><flat-pickr :config="config" v-model="item.date" ></flat-pickr></td>
                      <td><v-select :options="option_hours" v-model="item.hours"/></td>
                      <td><b-form-textarea rows="3" v-model="item.notes" max-rows="6" /></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr/>
              <legend><em class="fa fa-users"></em> Approval Information</legend>
              <list-supervisor :emp_id="emp_id" ></list-supervisor>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
        <button class="btn btn-warning float-right mr-1" @click="stat_id=1;handleOk($event)"> Submit </button>
        <button class="btn btn-primary float-right mr-1" @click="stat_id=0; handleOk($event)"> Save as Draft </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import {BForm, BFormGroup, BFormInput, BFormTextarea, BFormFile, BButton, BModal} from "bootstrap-vue"
import flatPickr from 'vue-flatpickr-component'
import vSelect  from "vue-select"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "../employee/ListSupervisor";
export default {
  name: "WorkFromHomeInput",
  components:{
    ListSupervisor,
    Breadcrumb,
    BForm,
    BFormGroup,
    BFormInput,
    flatPickr,
    BFormTextarea,
    BFormFile,
    BButton,
    BModal,
    vSelect
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      stat_id:0,
      emp_name:"",
      emp_id:"",
      input_data:{
        request_date:"",
        project:"",
        activity_start:"",
        end_activity:"",
        currency:"",
        reason:"",
        file:[]
      },
      items:[],
      items_delete:[],
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
      option_project:[],
      option_currency:[],
      option_hours:[],
    }
  },
  methods:{
    onSubmit(){
      if (!this.checkDateOfItem()){
        return
      }
      let userProfile = this.$store.getters.userProfile.data.attributes
      let payload = {
        emp_id:this.$store.getters.empId,
        user_id:this.$store.getters.userId,
        wfh_unit_id:userProfile.emp_unit_id,
        wfh_wfhstat_id:this.stat_id,
        wfh_activity:this.items,
        wfh_reason:this.input_data.reason,
        wfh_start:this.getMinDate(),
        wfh_end:this.getMaxDate(),
      }
      if(this.data !== null){
        payload.id = this.data.id
        payload.wfh_activity_delete = this.items_delete
        AxiosCall.Put(payload, urlApi.wfh.update).then(res=>{
          if(res.success){
            this.$parent.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.Post(payload, urlApi.wfh.add).then(res=>{
          if(res.success){
            this.$parent.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }

    },
    handleOk(evt){
      evt.preventDefault()
      this.onSubmit()
    },
    resetModal(){
      this.$parent.data = null
      this.input_data = {
        request_date:"",
        project:"",
        activity_start:"",
        end_activity:"",
        currency:"",
        reason:"",
        file:[]
      }
      this.items = []
      this.items_delete = []
      this.$refs.modal.hide()
    },
    onBack(){
      this.$router.push({path:"/work-from-home"})
    },
    addItem(){
      this.items.push({hours:8})
    },
    deleteItem(i){
      if(this.data !== null){
        if(this.items[i].id !== undefined) this.items_delete.push(this.items[i])
      }
      this.items.splice(i, 1)
    },
    getProject(){
      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id
      }
      AxiosCall.Get(payload, urlApi.project.projectAll).then(res=>{
        if(res.success){
          this.option_project = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    checkDateOfItem(){
      if (this.items.length == 0){
        this.$parent.errorMessage("Please add items.")
        return false
      }
      for(let data of this.items){

        if (data.project_id === undefined || data.project_id === "" || data.project_id === null){
          this.$parent.errorMessage("Please select project first.")
          return  false
        }

        if (data.date === undefined || data.date === "" || data.date === null){
          this.$parent.errorMessage("Please add date first.")
          return  false
        }
      }
      return true
    },
    getMaxDate(){
        let max_dt = this.items[0].date,
            max_dtObj = new Date(this.items[0].date);
        this.items.forEach(function(dt, index)
        {
          if ( new Date( dt.date ) > max_dtObj)
          {
            max_dt = dt.date;
            max_dtObj = new Date(dt.date);
          }
        });
        return max_dt;
    },
    getMinDate(){
      let min_dt = this.items[0].date,
          min_dtObj = new Date(this.items[0].date);
      this.items.forEach(function(dt, index)
      {
        if ( new Date( dt.date ) < min_dtObj)
        {
          min_dt = dt.date;
          min_dtObj = new Date(dt.date);
        }
      });
      return min_dt;
    },
    setData(){
      setTimeout(()=>{
        this.emp_id = this.$store.getters.empId.toString()
        if(this.data !== null){
          AxiosCall.Get({id:this.data.id}, urlApi.wfh.detail).then(res=>{
            if(res.success){
              this.input_data.reason = res.atributes.reason
              this.emp_id = res.atributes.emp_id.toString()
              this.items = JSON.parse(res.atributes.items) == null ? [] : JSON.parse(res.atributes.items)
            }
          })
        }
      }, 100)
    },
  },
  mounted() {
    for (let i = 1; i<=8; i++){
      this.option_hours.push({label:i+" hours", code:i})
    }
    let userProfile = this.$store.getters.userProfile.data.attributes
    this.emp_name = userProfile.emp_name

    this.getProject()
  },
}
</script>

<style scoped>

</style>